import { AnimationPlayer } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges
} from '@angular/core';
import { HEADER_TOP_MENU, LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { ContentDarkSite } from '../../model/content/contentDarkSite.model';
import { ContentPrimaryNavigation } from '../../model/content/contentprimarynavigation.model';
import { ContentSecondaryNavigation } from '../../model/content/contentsecondarynavigation.model';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';

@Component({
  selector: 'ngc-app-navigation-links',
  templateUrl: 'app-navigation-links.component.html'
})
export class AppNavigationLinksComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input()
  inMobile: boolean;

  @Input()
  newNavItem;

  @Input() isSlimHeader = false;
  @Output()
  navItemClicked: EventEmitter<string> = new EventEmitter();

  @Output()
  openAdvanceSearch: EventEmitter<boolean> = new EventEmitter();

  @Input()
  isNotHome: boolean;

  @Input()
  isMobileDevice: boolean;

  @Input()
  isloggedIn = false;

  @Input()
  showCheckInByDefault = false;

  @Input() isWarmState: boolean;
  isadvanceSearch = false;
  public mainNav: ContentPrimaryNavigation[];
  public secondaryNav: ContentSecondaryNavigation[];
  selectedNav = 'book';
  prevPrimaryNav = 'book';
  selectedSecNav = '';
  checkInWidget = 'check_in';
  contentServiceHeaderFooterSubscribe: Subscription;
  secLinkHoverTriggered = false;
  isWidgetSelected = false;
  isHome = true;
  selSearch = true;
  public timeouts = [];
  public player: AnimationPlayer;
  public darkSiteThemeContent: ContentDarkSite;
  isPrimaryNavExpandCollapse = false;
  isEnabled = 'true';
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private _el: ElementRef,
    private datalayer: DataLayer,
    private appconfig: ApplicationConfig,
    private loggingService: LoggingService,
    private adobeDataLayer: AdobeDataLayerService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  @HostListener('window:mouseover', ['$event']) onmouseover(event) {
    const secContainer = this._el.nativeElement.querySelector('.sec-links');
    const isSecNav =
      event.target.classList.contains('staticLink') ||
      event.target.classList.contains('static-link') ||
      (secContainer && secContainer.contains(event.target));
    if (!isSecNav) {
      this.selectedSecNav = '';
      if (this.newNavItem) {
        this.selectedNav = this.newNavItem;
      } else {
        this.selectedNav = this.prevPrimaryNav;
      }
    }
  }

  @HostListener('document:keyup', ['$event']) onkeyup(event) {
    const targetEle = event.target;
    const navItem = targetEle.parentElement.classList.contains('nav-item');
    const secLinks = targetEle.parentElement.querySelector(
      '.secondaryLinksContainer'
    );
    if (navItem && secLinks) {
      const removeNoneClass = targetEle.nextSibling
        ? targetEle.nextSibling.querySelector('.secondaryLinksContainer')
        : '';
      const deviceWidth = window.innerWidth;
      if (
        deviceWidth < 992 &&
        removeNoneClass &&
        removeNoneClass.classList &&
        removeNoneClass.classList.length > 0 &&
        event.keyCode === 13
      ) {
        const browserName = navigator.userAgent;
        const getbrowser =
          browserName.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf('android') > -1;
        if (getbrowser[1] === 'Chrome' && !isAndroid) {
          if (removeNoneClass.classList.contains('d-none')) {
            removeNoneClass.classList.remove('d-none');
          } else {
            removeNoneClass.classList.add('d-none');
          }
        }
      }
    }
    if (
      (event.target.classList &&
        event.target.classList.length > 0 &&
        event.target.classList.contains('sign-up')) ||
      event.target.classList.contains('logged-in-flyout')
    ) {
      this.selectedSecNav = '';
      if (this.newNavItem) {
        this.selectedNav = this.newNavItem;
      } else {
        this.selectedNav = this.prevPrimaryNav;
      }
      this.cdf.detectChanges();
    }
  }

  @HostListener('document:click', ['$event']) onMobClick(event) {
    const targetEle = event.target.classList.contains('navColumnHedingArrow')
      ? event.target.parentElement
      : event.target;
    const navItem = targetEle.parentElement
      ? targetEle.parentElement.classList.contains('nav-item')
      : '';
    const secLinks = targetEle.parentElement
      ? targetEle.parentElement.querySelector('.secondaryLinksContainer')
      : '';
    const deviceWidth = window.innerWidth;
    if (navItem && secLinks) {
      const removeNoneClass = targetEle.nextSibling
        ? targetEle.nextSibling.querySelector('.secondaryLinksContainer')
        : '';
      if (
        deviceWidth < 992 &&
        removeNoneClass &&
        removeNoneClass.classList &&
        removeNoneClass.classList.length > 0
      ) {
        if (removeNoneClass.classList.contains('d-none')) {
          this.closeSecondaryNavigation();
          removeNoneClass.classList.remove('d-none');
        } else {
          removeNoneClass.classList.add('d-none');
        }
      }
    } else if (!this.selectedSecNav && deviceWidth < 992) {
      this.closeSecondaryNavigation();
    }
  }

  closeSecondaryNavigation() {
    const secLinkcontainer = Array.prototype.slice.call(
      this._el.nativeElement.querySelectorAll('.secondaryLinksContainer')
    );
    secLinkcontainer.forEach((link) => {
      link.classList.add('d-none');
    });
  }

  ngOnInit() {
    if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
      this.isHome = false;
      this.selSearch = false;
      this.prevPrimaryNav = '';
    }
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      if (data.header.primaryNavigations) {
                        this.mainNav = Array.from(
                          data.header.primaryNavigations.values()
                        );
                      }
                      if (data.header.secondaryNavigation) {
                        this.secondaryNav = Array.from(
                          data.header.secondaryNavigation.values()
                        );
                      }
                      if (data.darkSite) {
                        this.darkSiteThemeContent = data.darkSite;
                        if (
                          this.darkSiteThemeContent.isEnabled === this.isEnabled
                        ) {
                          if (
                            this.darkSiteThemeContent.level ===
                              this.appconfig.get('APP_DARKSITE_LEVEL_1') ||
                            this.darkSiteThemeContent.level ===
                              this.appconfig.get('APP_DARKSITE_LEVEL_2')
                          ) {
                            this.isPrimaryNavExpandCollapse = true;
                          }
                        }
                      }
                      this.cdf.detectChanges();
                    }
                  },
                  (err) => {
                    if (this.appconfig.onBrowser) {
                      this.loggingService.log('Caught Error: ' + err);
                    }
                  }
                );
          }
        }
      });
    this.selecedtNavItem('-1');
  }

  KeyEventOnSecondaryNav(e, secNavItemId) {
    this.selectedNav = null;
    if (e.keyCode === 13) {
      // enter key
      e.preventDefault();
      // this.selectedSecNav = secNavItemId;
      this.mouseHoverSecLinks(e, secNavItemId);
    }
    if (e.keyCode === 39 || e.keyCode === 40) {
      // right arrow & down arrow
      e.preventDefault();
      const nextElm = e.target.parentElement.nextElementSibling;
      if (nextElm != null && nextElm.classList.contains('staticLink')) {
        nextElm.firstChild.focus();
        nextElm.firstChild.click();
      } else {
        this._el.nativeElement.querySelector('.nav-link-book').focus();
        this._el.nativeElement.querySelector('.nav-link-book').click();
      }
    }
    if (e.keyCode === 37 || e.keyCode === 38) {
      // left arrow & up arrow
      e.preventDefault();
      if (e.target.parentElement.previousElementSibling != null) {
        e.target.parentElement.previousElementSibling.firstChild.focus();
        e.target.parentElement.previousElementSibling.firstChild.click();
      }
    }
  }

  KeyEventOnPrimaryNav(
    e,
    navItem,
    legacyAppUrl = '',
    redirectMobile = '',
    redirectMobileUrl = ''
  ) {
    if (e.keyCode === 40) {
      // down arrow
      e.preventDefault();
      this.primaryNavClicked(
        navItem,
        legacyAppUrl,
        redirectMobile,
        redirectMobileUrl
      );
      this.setTrackingObject(navItem, e);
    } else if (e.keyCode === 9 && !(e.shiftKey && e.keyCode === 9)) {
      const mytripsFocus = e.target.classList.contains('nav-link-mytrips');
      const focusParticular = document.querySelector(
        '.view-trip-details a.focusable-element'
      ) as HTMLElement;
      if (mytripsFocus) {
        const focusElementNav = document.querySelector('.view-trip-details');
        if (focusElementNav) {
          focusElementNav.setAttribute('tabindex', '0');
          focusParticular.focus();
          e.preventDefault();
        }
      }
    }
  }

  selecedtNavItem(selectedItem) {
    if (this.isPrimaryNavExpandCollapse) {
      this.selectedNav = '';
      this.navItemClicked.emit(selectedItem);
    } else {
      this.selectedNav = selectedItem;
      this.navItemClicked.emit(selectedItem);
    }
  }

  primaryNavClicked(
    widgetId: string,
    legacyAppUrl = '',
    redirectMobile = '',
    redirectMobileUrl = ''
  ) {
    if (widgetId === 'book') {
      this.isadvanceSearch = !this.isadvanceSearch;
      if (this.selSearch) {
        this.openAdvanceSearch.emit(this.isadvanceSearch);
      }
      this.selSearch = true;
    }
    if (this.isSlimHeader) {
      if (isPlatformBrowser(this.platformId)) {
        // rsb-16343 Display login screen for persistent login scenario
        if (legacyAppUrl === '/mytrips/' && this.isWarmState) {
          window.location.href = `/login/loginPage?refreshURL=${legacyAppUrl}`;
        } else {
          window.location.href = legacyAppUrl;
        }
      }
    } else {
      if (
        this.isMobileDevice &&
        this.inMobile &&
        redirectMobile !== '' &&
        redirectMobile.toLowerCase() === 'true' &&
        redirectMobileUrl !== ''
      ) {
        window.location.href = redirectMobileUrl;
      } else {
        if (this.isloggedIn && this.showCheckInByDefault) {
          this.showCheckInByDefault = false;
        }
        this.selecedtNavItem(widgetId);
      }
    }
  }

  setTrackingObject(selectedItem, e): void {
    e.preventDefault();
    this.datalayer.setTrackingObjectProp1('header:' + selectedItem, e.target);
    const menus = {
      book: HEADER_TOP_MENU.BOOK,
      check_in: HEADER_TOP_MENU.CHECK_IN,
      my_trips: HEADER_TOP_MENU.MY_TRIPS,
      flightstatus: HEADER_TOP_MENU.FLIGHT_STATUS,
      secondarynav: HEADER_TOP_MENU.TRAVEL_INFO,
      'skym-miles': HEADER_TOP_MENU.SKYMILES,
      more: HEADER_TOP_MENU.NEED_HELP
    };
    this.adobeDataLayer.updateAnalytics(selectedItem, menus[selectedItem]);

    if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
      this.isWidgetSelected = true;
    }
    if (e.target.classList.contains('static-link')) {
      this.mouseHoverSecLinks(e, selectedItem);
    }
  }

  mouseHoverSecLinks(e, secNavItemId) {
    this.selectedNav = null;
    if (this.inMobile) {
      this.secLinkHoverTriggered = true;
      this.selectedSecNav = secNavItemId;
      this.cdf.detectChanges();
    } else {
      if (this.selectedSecNav !== secNavItemId) {
        this.timeouts.push(
          setTimeout(() => {
            this.selectedSecNav = secNavItemId;
            this.cdf.detectChanges();
          }, 250)
        );
      }
    }
  }

  mouseOutSecLinks() {
    if (this.isHome || !this.isNotHome) {
      if (this.isPrimaryNavExpandCollapse) {
        this.selectedNav = '';
      }
    } else if (this.isNotHome) {
      this.selectedNav = '';
      this.cdf.detectChanges();
    }
  }

  checkIfSecLinksDisplayed(activeElement) {
    if (activeElement.classList.contains('active-menu')) {
      return activeElement.children[1].offsetTop !== 3;
    } else if (activeElement.classList.contains('static-link-secondarynav')) {
      return activeElement.parentElement.children[0].classList.contains(
        'sec-links'
      );
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isloggedIn && this.showCheckInByDefault) {
      setTimeout(() => {
        this.selectedNav = this.checkInWidget;
        this.showCheckInByDefault = false;
        this.selecedtNavItem(this.checkInWidget);
      }, 100);
    } else if (
      this.isWidgetSelected ||
      this.appconfig.get('APP_DISABLE_LEGACY') === 'true'
    ) {
      this.selectedNav = this.newNavItem;
    } else {
      this.selectedNav = '';
    }
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
    this.secLinkHoverTriggered = false;
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.stopTimeout();
    this.cdf.detach();
  }
}
